export default __webpack_public_path__ + "images/KP.34f2e69.png";